import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SectionCombinator.html?raw';
import { TiClassNames, TiEntities, TiInterfaces } from "../../TiTypes";
import TiMainRouteView from '../MainRouteView';
import PageStack from '../../../../moreCore/UI/Tabbing/PageStack';
import ResourcePicker from '../../../../moreCore/UI/ResourcePicker/ResourcePicker';
import ExpandableSection from '../../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings, HTMLElementWithExpander } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";

 




interface SectionsRegistryEntry {
    saveData: TiInterfaces.SimpleSectionData;
    //sectionSlotEntity: TiEntities.SectionTimeSlotEntity;
    resourcePickerContainer: HTMLElement;
    resourcePicker: MdsLax<InstanceType<typeof ResourcePicker>>
    sectionLabel: string;
    selectedSlotLabel: string;
    selectedSlotEntity: TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension
    index: number;
}
class TiRouteSectionCombinator extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private sectionLoadEarlierSlots: HTMLElement;
    private btnLoadEarlierSlots: HTMLElement;
    private txtRouteName: HTMLElement;
    private expanderContent: HTMLElement;
    private routeViewContainer: HTMLElement;
    private routeViewExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private containerSubmitRoute: HTMLElement;

    private mainRouteSlot: TiEntities.MainRouteTimeSlotEntity_Aliased;

    private mainRouteEntity: TiEntities.MainRoute;
    private dummyMainRouteSlot: Partial<TiEntities.MainRouteTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension>

    private formData: TiInterfaces.CustomMainRouteData;
    private sectionsRegistry: Array<SectionsRegistryEntry>;

    private routeView: MdsLax<InstanceType<typeof TiMainRouteView>>;

    private sectionsPagestack: MdsLax<InstanceType<typeof PageStack>>;
    private sectionsPagingContainer: HTMLElement;

    private _isValid: boolean = false;

    autoEmitValid: boolean = false;
    

    setup(mainRouteID: string, logisticResourceID: string) {
        this._loadMainRouteEntity(mainRouteID, logisticResourceID);
    }

    private _loadMainRouteEntity(mainRouteID: string, logisticResourceID: string) {

        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API_TiRouteSectionCombinator_GetMainRouteEntity",
            {
                mainRouteID: mainRouteID,
                logisticResourceID: logisticResourceID
            },
            lang.hitch(this, this._onLoadMainRoutEntity),
            lang.hitch(this, this._onLoadMainRoutEntityError)
        );
    }

    private _onLoadMainRoutEntityError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    private _onLoadMainRoutEntity(response: TiEntities.MainRoute) {

        this._setMainRouteEntity(response);

        this.StandbyStop();
    }

    private _setMainRouteEntity(mainRoute: TiEntities.MainRoute) {

        this.mainRouteEntity = mainRoute;

        if (!this.mainRouteEntity) {
            alert(this.id + ": no main route entity!");
            return;
        }

        this.formData = {
            mainRouteID: this.mainRouteEntity.ID,
            sections: []
        };

        let label = this.mainRouteEntity.name;
        if (this.canTranslate("TiBooking__LabelSuffix_CustomRoute")) label += this.translate("TiBooking__LabelSuffix_CustomRoute");

        this.dummyMainRouteSlot = {
            ID: "dummy-" + this.mainRouteEntity.ID,
            _isDummy: true,
            _placeholderLabel: label,
            mainRouteName: label,
            divisionID: this.mainRouteEntity.ref_division.ID,
            mainRouteID: this.mainRouteEntity.ID,
            sectionSlotAssignments: [],
            date_start: this.mainRouteEntity.date_start,
            date_end: this.mainRouteEntity.date_end,
            name: this.mainRouteEntity.name + " CUSTOM"
        };

        this.UiModder.domAttr.set(this.txtRouteName, "innerHTML", this.mainRouteEntity.name);


        this.sectionsRegistry = [];

        // btn zum früher-Laden retten, falls zuvor schon im Pagingcontainer:
        this.hideNode(this.sectionLoadEarlierSlots);
        this.UiModder.domConstruct.place(this.sectionLoadEarlierSlots, this.domNode, "before");
        


        this.UiModder.domConstruct.empty(this.sectionsPagingContainer);
        this.sectionsPagestack = new PageStack();
        this.sectionsPagestack.placeAt(this.sectionsPagingContainer);


        let sortedSections = this.mainRouteEntity.EL_section_main_route_main_route.sort((a, b) => { return a.sorting - b.sorting; });
        for (let htSection of sortedSections) {

            let sectionSaveData: TiInterfaces.SimpleSectionData = {
                sorting: htSection.sorting,
                sectionID: htSection.ref_section.ID,
                sectionSlotID: null
            };

            this.formData.sections.push(sectionSaveData);

            let pickerContainer = this.UiModder.domConstruct.create("div",
                {
                    className: "w3-block",
                    style: {
                        "minHeight": "5em"
                    },
                    id: "container-" + sectionSaveData.sectionID
                });
            let regEntry: SectionsRegistryEntry = {
                sectionLabel: htSection.ref_section.name,
                resourcePickerContainer: pickerContainer,
                saveData: sectionSaveData,
                //sectionSlotEntity: null,
                resourcePicker: null,
                selectedSlotLabel: null,
                selectedSlotEntity: null,
                index: this.sectionsRegistry.length
            };

            this.sectionsRegistry.push(regEntry);

            this.sectionsPagestack.addPage(pickerContainer, {
                label: regEntry.sectionLabel,
                name: regEntry.saveData.sectionID,
                enabled: regEntry.index == 0, // initial mal nur den ersten Tab aktivieren
                insertWithoutPadding: true,
            });

            if (this.hasUserRole("TI_AllowPastSlotSelection") && regEntry.index == 0) {
                this.UiModder.domConstruct.place(this.sectionLoadEarlierSlots, regEntry.resourcePickerContainer, "before");
                this.hideNode(this.sectionLoadEarlierSlots, false);
            }
        }

        this.sectionsPagestack.on("pageActivated", lang.hitch(this, this._onPagestackSwitch));


        this.continueWithSelectedSection(null);

        this.routeViewExpander.toggleExpand(true);

    }

    private _onPagestackSwitch(newActivePageName: string) {
        this._setupRouteView();
    }

    getCustomRouteSaveData(): TiInterfaces.CustomMainRouteData{
        if (!this._isValid) return null;

        return this.formData;
    }
    getCustomRouteSlot(): TiEntities.MainRouteTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension{
        if (!this._isValid) return null;

        return this.dummyMainRouteSlot as any
    }

    private getRegistryEntryBySectionID(sectionID: string): SectionsRegistryEntry {
        for (let entry of this.sectionsRegistry) {
            if (entry.saveData?.sectionID == sectionID) {
                return entry;
            }
        }

        return null;
    }

    private continueWithSelectedSection(currentSection: SectionsRegistryEntry) {


        // wir haben: entweder noch garnix gewählt oder x von y Sections fertig gewählt
        // wir brauchen: die benötigte Section (x+1)
        // also targetSection aus der Registry holen

        let previousSectionSlotID = null;
        let targetSectionID = this.sectionsRegistry[0].saveData.sectionID;
        let nextIndex = 0;

        // aus der Registry das nächste Element holen:
        if (currentSection) {
            previousSectionSlotID = currentSection.saveData.sectionSlotID;
            nextIndex = currentSection.index + 1;
        }


        if (this._checkValidSelection() == true) {
            this.containerSubmitRoute.scrollIntoView({ behavior: "smooth", block: "nearest" });
            return;
        }


        targetSectionID = this.sectionsRegistry[nextIndex].saveData.sectionID;


        this.loadNextRouteSection(previousSectionSlotID, targetSectionID, nextIndex);

    }

    private _onClick_LoadEarlier(evt: MouseEvent) {
        if (this.hasUserRole("TI_AllowPastSlotSelection")) {
            this.disableNode(this.btnLoadEarlierSlots);
            this.loadNextRouteSection(null, this.sectionsRegistry[0].saveData.sectionID, 0, true);
        }
    }

    private loadNextRouteSection(previousSectionSlotID: string, targetSectionID: string, nextRegistryIndex: number, bLoadPastSlot?: boolean) {

        let reg = this.getRegistryEntryBySectionID(targetSectionID);

        this._handleSelectedSections(targetSectionID);

        let text = this.translate("TiBooking__Label_LoadingNextSection");
        text += " " + reg.sectionLabel;

        this.StandbyStartWithText(text, reg.resourcePickerContainer);


        this.RequestManager.callfunction("Webtool_API_TiRouteSectionCombinator_GetSelectableRouteSectionSlots",
            {
                mainRouteID: this.mainRouteEntity.ID,
                previousSectionSlotID: previousSectionSlotID,
                targetSectionID: targetSectionID,
                loadPastSlot: bLoadPastSlot === true && nextRegistryIndex == 0
            },
            lang.hitch(this, this._onLoadNextRouteSectionResponse, nextRegistryIndex),
            lang.hitch(this, this._onLoadNextRouteSectionError)
        );
    }

    private _onLoadNextRouteSectionError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    private _onLoadNextRouteSectionResponse(registryIndex: number, response: {
        resourcpickerConfig: ResourcePicker.ResourcePickerConfiguration,
        slotEntities: Array<TiEntities.SectionTimeSlotEntity_Aliased>,
        todayID: string
    }) {

        this.StandbyStop();

        let reg = this.sectionsRegistry[registryIndex];

        let resourcePicker = new ResourcePicker();
        resourcePicker.setLayout(null, "fullwidth");


        resourcePicker.placeAt(reg.resourcePickerContainer, "only");
        reg.resourcePicker = resourcePicker;

        resourcePicker.setConfiguration(response.resourcpickerConfig);

        resourcePicker.adjustHeightFactorToContent(3, 0.5);

        resourcePicker.on("change", lang.hitch(this, this._onSelectSectionSlot, reg, response.slotEntities));

        if (reg.index == 0) {
            resourcePicker.scrollToGroup(response.todayID)
        }
    }

    private _onSelectSectionSlot(sectionRegistry: SectionsRegistryEntry, slotEntities: Array<TiEntities.SectionTimeSlotEntity_Aliased>, value) {
        
        let values = sectionRegistry.resourcePicker.getValue();

        // alles ab dieser Teilstrecke wieder resetten!
        for (let reg of this.sectionsRegistry) {
            if (reg.index >= sectionRegistry.index) {
                reg.selectedSlotLabel = null;
                reg.saveData.sectionSlotID = null;
                reg.selectedSlotEntity = null;
            }
        }


        if (values.length == 1) {
            let selectedSectionSlot = values[0];
            sectionRegistry.saveData.sectionSlotID = selectedSectionSlot;

            let displayValue = sectionRegistry.resourcePicker.getValue(true)[0];

            sectionRegistry.selectedSlotLabel = displayValue;

            for (let entity of slotEntities) {
                if (entity.ID == selectedSectionSlot) {
                    sectionRegistry.selectedSlotEntity = entity;
                    break;
                }
            }

            this._handleSelectedSections();

            this.continueWithSelectedSection(sectionRegistry);
        } else {

            //this.continueWithSelectedSection(firstValidReg);
            this._handleSelectedSections(sectionRegistry.saveData.sectionID);
        }
    }

    private _handleSelectedSections(targetSectionID?: string) {
        for (let reg of this.sectionsRegistry) {
            this.sectionsPagestack.enablePage(reg.saveData.sectionID,
                reg.saveData.sectionSlotID != null || reg.saveData.sectionID == targetSectionID);

            let newIcon = "";
            let newLabel = reg.sectionLabel;
            if (reg.saveData.sectionSlotID) {
                newLabel += " - " + reg.selectedSlotLabel;
                newIcon = "fas fa-check-circle";
            }

            this.sectionsPagestack.setPageLabel(reg.saveData.sectionID, newLabel, newIcon);
        }

        if (targetSectionID) this.sectionsPagestack.activatePageByName(targetSectionID);

        this._checkValidSelection();

        
        this._setupRouteView();

    }


    private _setupRouteView() {

        let activePage = this.sectionsPagestack.getActivePageName();
        let highlightTarget = null;

        if (!this.mainRouteEntity) {
            this.dummyMainRouteSlot = null;
            return;
        }


        this.dummyMainRouteSlot.sectionSlotAssignments = [];
        let sections: Array<TiEntities.SectionTimeSlotEntity_Aliased> = [];

        for (let reg of this.sectionsRegistry) {


            let slotEntity: TiEntities.SectionTimeSlotEntity_Aliased & TiInterfaces.DummyPropertyExtension = reg.selectedSlotEntity;
            if (!slotEntity) {
                slotEntity = {
                    _isDummy: true,
                    ID: "dummy-" + reg.saveData.sectionID,
                    _placeholderLabel: reg.sectionLabel,
                    Classname: TiClassNames.section_main_route_timeslot
                } as any;
            }

            // wenn die gewählte Pagestack-Seite zur Section des Slots passt: highlighten
            if (reg.saveData.sectionID == activePage) {
                highlightTarget = slotEntity.ID;
                this.hideNode(this.sectionLoadEarlierSlots, reg.index != 0);

            }

            let dummySlotAssignment: TiEntities.SectionTimeSlotAssignmentEntity_Aliased = {
                //mainRouteSlot: this.dummyMainRouteSlot as any, // ACHTUNG: wird sonst unendlich zyklisch!!
                ID: null,
                sectionSlot: slotEntity
            } as any;

            this.dummyMainRouteSlot.sectionSlotAssignments.push(dummySlotAssignment)
            sections.push(slotEntity);
        }


        this.routeView = new TiMainRouteView();

        this.routeView.setConfig({
            sectionsConfig: {
                enableBookingStatus: false,
                highlight:true,
                showExtendedInformation: true
            }, highlightMode: "fadeAfterTarget",
            highlightSectionSlotID: highlightTarget
        });

        this.routeView.placeAt(this.routeViewContainer, "only");

        this.routeView.setData(this.dummyMainRouteSlot as any,
            sections);


        this.hideNode(this.routeViewContainer, false);
    }

    private _checkValidSelection(bForceEmit?: boolean): boolean {

        let bValid = true;
        // zur Sicherheit nochmal prüfen:
        for (let reg of this.sectionsRegistry) {
            if (!reg.saveData.sectionSlotID) {
                bValid = false;
                break;
            }
        }


        if (this._isValid != bValid || bForceEmit === true) {
            this._isValid = bValid;        

            this.hideNode(this.containerSubmitRoute, !bValid);
            this.routeViewExpander.setMarking(bValid ? ExpandableSectionMarkings.checked : ExpandableSectionMarkings.default);

            if (this.autoEmitValid == true || bForceEmit == true) {
                setTimeout(lang.hitch(this, this.emit, "valid", bValid), 10); // in Echtzeit gehts ned. da steht die letzte gewählte Section nicht im Ergebnis.
            }
        }


        return bValid;
    }

    private _onClick_SubmitRoute(evt: MouseEvent) {
        
        this._checkValidSelection(true);
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.routeViewExpander = new ExpandableSection();

        this.routeViewExpander.placeAt(this.expanderContent, "after");
        this.routeViewExpander.setup(this.expanderContent, this.translate("TiBooking__Heading_OverviewCreatedCustomRoute"), "medium", true, false, true);

        this.RequestManager.handleAs = "jsonWithDate";


    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);

    }

}

export default mdsWidget(TiRouteSectionCombinator);